import React, { useState, useEffect } from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core/styles';
import * as logger from "../../../logger";
import { deleteParty } from '../../../store/actions/partiesActionCreator';
import { connect } from "react-redux";

const useStyles = makeStyles((theme) => ({
    cancelV1: {
        color: '#6b778c', fontWeight: 'bold', fontSize: '16px', marginRight: '6px', letterSpacing: '0.05em'
    },
    deleteV1: {
        color: 'red', fontWeight: 'bold', fontSize: '16px', letterSpacing: '0.05em'
    },
    divV1: {
        fontWeight: 300, fontSize: 16
    }
}));

const DeletePartyDialog = ({ open, partyId, onConfirm, onClose, dispatchDeleteParty }) => {

    const [dialogOpen, setDialogOpen] = useState(open);

    const classes = useStyles();

    const handleDialogClose = () => {
        setDialogOpen(false);
        onClose();
    }

    const onDelete = () => {
        dispatchDeleteParty(partyId,
            (data) => {
                if (data && data.status && data.status.code == 200) {
                    logger.log("Delete Party Dialog Dweb", "Delete Party Successfull");
                    setDialogOpen(false);
                    onConfirm();
                }
            },
            () => {
                logger.log("Delete Party Dialog Dweb", "Delete Party Failed");
            }
        )
    }

    return (
        <>
            <Dialog
                fullWidth={true}
                maxWidth='xs'
                disableBackdropClick={true} disableEscapeKeyDown={true} open={dialogOpen} onClose={handleDialogClose}
            >
                <DialogContent>
                    <div className={classes.divV1}>Do you want to delete the Party ? </div>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleDialogClose}>
                        <span className={classes.cancelV1}>
                            CANCEL
                        </span>
                    </Button>
                    <Button onClick={onDelete}>
                        <span className={classes.deleteV1}>
                            DELETE
                        </span>
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    )
}
const mapStateToProps = (state) => ({});
const mapDispatchToProps = (dispatch) => ({
    dispatchDeleteParty: (id, onSuccess, onFailure) => dispatch(deleteParty(id, onSuccess, onFailure))
});

export default connect(mapStateToProps, mapDispatchToProps)(DeletePartyDialog);